/**
 * Created by DejanK on 12/27/2016.
 */
import angular from 'angular';

import headers from './headers';
import tooltips from './rb-tooltip/rb-tooltip.module';
import rbFloat from './rb-float/rb-float.module';
import rbFixedOnScroll from './rb-fixed-on-scroll/rb-fixed-on-scroll.module';
import rbVirtualRepeat from './rb-virtual-repeat/rb-virtual-repeat.module';

import rbRating from './rb-rating/rb-rating.cmp'
import rbDate from './rb-date-filter/rb-date.filter'

export default angular.module('rb.core.ui', [
  headers,
  tooltips.name,
  rbFloat.name,
  rbFixedOnScroll.name,
  rbVirtualRepeat.name,
])

  .component('rbRating', rbRating)
  .filter('rbDate', rbDate)
